const Tab = () => null;

export default Tab;
